module.exports = __webpack_public_path__ + "img/map.87a71456.png";